import Moment from 'moment';

import { maxPerPage } from '@/components/myTimekeep/Timekeep/PortfolioList/Config';

const initialState = {
  filters: {
    displayBy: 'project',
    period: {
      from: Moment().startOf('week').format('MM/DD/YYYY'),
      to: Moment().endOf('week').format('MM/DD/YYYY'),
      date: `${Moment().startOf('week').format('DD')} to ${Moment().endOf('week').format('DD-MMM YYYY')}`, // dateLabel
    },
    leadType: 'workstreamILead',
    dropdownList: [],
  },
  userList: {
    page: 1,
    list: [],
    hasMore: false,
    totalCount: 0,
  },
  projectList: {
    page: 1,
    hasMore: false,
    list: [],
    totalCount: 0,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'TIMELOG_PORTFOLIO_SET_PERIOD':
      return {
        ...state,
        filters: {
          ...state.filters,
          period: {
            ...state.period,
            [action.periodType]: action.value,
          },
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_PERIOD_FROM_TO':
      return {
        ...state,
        filters: {
          ...state.filters,
          period: {
            from: action.from,
            to: action.to,
            date: action.date,
          },
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_FILTER_LEAD_TYPE':
      return {
        ...state,
        filters: {
          ...state.filters,
          leadType: action.leadType,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_FILTER_DISPLAY_BY':
      return {
        ...state,
        filters: {
          ...state.filters,
          displayBy: action.displayBy,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_FILTER_DROPDOWN':
      return {
        ...state,
        filters: {
          ...state.filters,
          dropdownList: action.dropdownList,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_FILTERS':
      return {
        ...state,
        filters: {
          period: {
            from: action.period.from,
            to: action.period.to,
          },
          displayBy: action.filters.displayBy,
          leadType: action.filters.leadType,
          dropdownList: action.filters.dropdownList,
        },
      };

    case 'TIMELOG_PORTFOLIO_UPDATE_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filter]: state.filters[action.filter].map((f) => {
            if (f.id === action.id) {
              return {
                ...f,
                ...action.update,
              };
            }

            return f;
          }),
        },
      };

    case 'TIMELOG_PORTFOLIO_SELECT_ALL_DROPDOWN':
      return {
        ...state,
        filters: {
          ...state.filters,
          dropdownList: state.filters.dropdownList.map((f) => {
            return { ...f, isSelected: action.value };
          }),
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_USER_LIST':
      return {
        ...state,
        userList: {
          ...state.userList,
          list: action.list,
          page: action.page,
          totalCount: action.totalCount,
          hasMore: action.totalCount > action.page * maxPerPage,
        },
        projectList: {
          ...state.projectList,
          page: 1,
          list: [],
          hasMore: false,
          totalCount: 0,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_PROJECT_LIST':
      return {
        ...state,
        projectList: {
          ...state.projectList,
          list: action.list,
          page: action.page,
          totalCount: action.totalCount,
          hasMore: action.totalCount > action.page * maxPerPage,
        },
        userList: {
          ...state.userList,
          page: 1,
          list: [],
          hasMore: false,
          totalCount: 0,
        },
      };

    case 'TIMELOG_PORTFOLIO_LOAD_MORE_PROJECT_LIST':
      return {
        ...state,
        projectList: {
          ...state.projectList,
          page: state.projectList.page + 1,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_PAGE_PROJECT_LIST':
      return {
        ...state,
        projectList: {
          ...state.projectList,
          page: action.page,
        },
      };

    case 'TIMELOG_PORTFOLIO_SET_PAGE_USER_LIST':
      return {
        ...state,
        projectList: {
          ...state.projectList,
          page: action.page,
        },
      };

    case 'TIMELOG_PORTFOLIO_LOAD_MORE_USER_LIST':
      return {
        ...state,
        userList: {
          ...state.userList,
          page: state.userList.page + 1,
        },
      };

    case 'TIMELOG_PORTFOLIO_TOGGLE_USER_LIST_ROW':
      return {
        ...state,
        userList: {
          ...state.userList,
          list: state.userList.list.map((user) => {
            if (user.result.length && user.result[0].userId === action.userId) {
              user.isToggled = !user.isToggled;
            }
            return user;
          }),
        },
      };

    case 'TIMELOG_PORTFOLIO_TOGGLE_PROJECT_LIST_ROW':
      return {
        ...state,
        projectList: {
          ...state.projectList,
          list: state.projectList.list.map((project) => {
            if (project.id === action.projectId) {
              project.isToggled = !project.isToggled;
            }
            return project;
          }),
        },
      };

    case 'TIMELOG_PORTFOLIO_RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
